<mat-card class="animate__animated animate__fadeIn">
 <app-card-header title="Reports" subtitle="Principal Investigator Report"></app-card-header>
 <div class="report-note">
 <p class="note-warning">Red Results indicate the PI is Inactive and they are still listed as a PI on Active, Exempt or Pending Protocol</p>
 </div>

 <mat-card-content class="p-3">
 <div class="search-div">
 <form class="filters" [formGroup]="form" (ngSubmit)="fetch()">
 <div class="row">

 <!-- Protocol Status Filter -->
 <div class="col-md-3">
 <mat-form-field appearance="fill">
 <mat-label>Protocol Status</mat-label>
 <mat-select formControlName="protocolStatuses" multiple>
 <mat-option (click)="form.patchValue({ protocolStatuses: protocolStatusOptions }); $event.stopPropagation();">Select All</mat-option>
 <mat-option (click)="form.patchValue({ protocolStatuses: [] }); $event.stopPropagation();">Clear</mat-option>
 <mat-option *ngFor="let ps of protocolStatusOptions" [value]="ps">{{ ps }}</mat-option>
 </mat-select>
 </mat-form-field>
 </div>

 <!-- User Status (default Active) -->
 <div class="col-md-3">
 <mat-form-field appearance="fill">
 <mat-label>User Status</mat-label>
 <mat-select formControlName="userStatus">
 <mat-option value="All">All</mat-option>
 <mat-option value="Active">Active</mat-option>
 <mat-option value="Inactive">Inactive</mat-option>
 </mat-select>
 </mat-form-field>
 </div>

 <div class="col-md-3">
 <mat-form-field appearance="fill">
 <mat-label>First Name</mat-label>
 <input matInput formControlName="firstName" placeholder="first name" />
 </mat-form-field>
 </div>

 <div class="col-md-3">
 <mat-form-field appearance="fill">
 <mat-label>Last Name</mat-label>
 <input matInput formControlName="lastName" placeholder="last name" />
 </mat-form-field>
 </div>

 <div class="col-md-3">
 <mat-form-field appearance="fill">
 <mat-label>Search by Institution</mat-label>
 <input type="text" matInput formControlName="institutionId" [matAutocomplete]="institutionAutoComplete">
 <mat-autocomplete #institutionAutoComplete="matAutocomplete" [displayWith]="displayFn">
 <mat-option *ngFor="let institution of filteredInstitutions$ | async" [value]="institution">
 {{institution.name}}
 </mat-option>
 </mat-autocomplete>
 </mat-form-field>
 </div>

 </div>
 <div class="d-flex justify-content-center mt-3">
 <button type="button" class="mr-3" mat-stroked-button color="warn" (click)="reset()">Clear
 Search</button>
 <button class="mr-3" mat-stroked-button color="primary" type="submit" (click)="fetch()">Submit</button>
 <div class="button-container">
 <span class="spinner-container" *ngIf="excelLoading">
 <mat-spinner diameter="24"></mat-spinner>
 </span>
 <button mat-stroked-button color="accent" type="button" [disabled]="excelLoading" (click)="downloadExcel()">Download
 Excel</button>
 </div>
 </div>
 </form>
 </div>

 </mat-card-content>
 <div *ngIf="tableLoading"
 style="position: absolute; right:50%; top:35%;">
 <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
</div>
 <!-- TOP PAGER -->
 <mat-paginator
 [length]="total"
 [pageIndex]="reportService.pageIndex -1"
 [pageSize]="reportService.pageSize"
 [pageSizeOptions]="[10,50,100]"
 (page)="onPage($event)">
 </mat-paginator>


 <div class="table-container" [class.loading]="tableLoading">
 <table mat-table [dataSource]="data" matSort (matSortChange)="onSortChange($event)">

 <ng-container matColumnDef="firstName">
 <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName">First Name</th>
 <td mat-cell *matCellDef="let r" [class.inactive-row]="r.status === 'Inactive'">{{ r.firstName }}</td>
 </ng-container>

 <ng-container matColumnDef="lastName">
 <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName">Last Name</th>
 <td mat-cell *matCellDef="let r" [class.inactive-row]="r.status === 'Inactive'">{{ r.lastName }}</td>
 </ng-container>

 <ng-container matColumnDef="email">
 <th mat-header-cell *matHeaderCellDef mat-sort-header="email">Email</th>
 <td mat-cell *matCellDef="let r" [class.inactive-row]="r.status === 'Inactive'">
 <a *ngIf="r.email" [href]="'mailto:' + r.email">{{ r.email }}</a>
 </td>
 </ng-container>

 <ng-container matColumnDef="phone">
 <th mat-header-cell *matHeaderCellDef mat-sort-header="phone">Phone</th>
 <td mat-cell *matCellDef="let r" [class.inactive-row]="r.status === 'Inactive'">{{ r.phone }}</td>
 </ng-container>

 <ng-container matColumnDef="institution">
 <th mat-header-cell *matHeaderCellDef mat-sort-header="institution">Institution(s)</th>
 <td mat-cell *matCellDef="let r" [class.inactive-row]="r.status === 'Inactive'">{{ r.institution }}</td>
 </ng-container>

 <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
 <tr mat-row *matRowDef="let r; columns: displayedColumns"></tr>
 </table>

 <!-- BOTTOM PAGER -->
<mat-paginator
 [length]="total"
 [pageIndex]="reportService.pageIndex -1"
 [pageSize]="reportService.pageSize"
 [pageSizeOptions]="[10,50,100]"
 (page)="onPage($event)">
</mat-paginator>
 </div>
</mat-card>
